export default "__VITE_ASSET__BMd2yUgs__"